import React, { useEffect, useRef, useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';

/**
 * Selector simulado con divs (no <select> nativo), propio del dashboard.
 * options: [{ value, label }]
 */
const DtDropdown = ({ options, value, onChange, placeholder }) => {
  const [abierto, setAbierto] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const alClickFuera = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setAbierto(false);
    };
    document.addEventListener('mousedown', alClickFuera);
    return () => document.removeEventListener('mousedown', alClickFuera);
  }, []);

  const seleccionada = options.find((opt) => opt.value === value);

  const elegir = (val) => {
    onChange(val);
    setAbierto(false);
  };

  return (
    <div className={`dt-dropdown${abierto ? ' dt-dropdown-abierto' : ''}`} ref={ref}>
      <button
        type="button"
        className="dt-dropdown-trigger"
        onClick={() => setAbierto((prev) => !prev)}
        aria-expanded={abierto}
      >
        <span className={seleccionada ? 'dt-dropdown-valor' : 'dt-dropdown-placeholder'}>
          {seleccionada ? seleccionada.label : placeholder}
        </span>
        <FiChevronDown className="dt-dropdown-chevron" />
      </button>
      {abierto && (
        <div className="dt-dropdown-panel">
          <div
            className={`dt-dropdown-opcion${value === '' ? ' dt-dropdown-opcion-activa' : ''}`}
            onClick={() => elegir('')}
          >
            {placeholder}
          </div>
          {options.map((opt) => (
            <div
              key={opt.value}
              className={`dt-dropdown-opcion${value === opt.value ? ' dt-dropdown-opcion-activa' : ''}`}
              onClick={() => elegir(opt.value)}
            >
              {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DtDropdown;
